import axios from "axios";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

const token = localStorage.getItem("token");

if (token) {
  Object.assign(headers, {
    Authorization: `Bearer ${token}`,
  });
}

const APIClient = axios.create({
  baseURL: `https://be.sitapic.com/admin/public`,
  headers: headers,
});
// const APIClient = axios.create({
//   baseURL: `http://192.168.68.59:7000`,
//   headers: headers,
// });

export default APIClient;
